import { Select } from 'antd';
import React from 'react'


const { Option } = Select;

export default function SelectInterval(props) {

    function onChange(value) {
        console.log(`selected ${value}`);
        props.changeInterval(value);
    }

    function onBlur() {
        console.log('blur');
    }

    function onFocus() {
        console.log('focus');
    }

    function onSearch(val) {
        console.log('search:', val);
    }

    return (
        <div>
            <Select
                showSearch
                style={{ width: 400 }}
                placeholder="Intervallo di tempo"
                optionFilterProp="children"
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                defaultValue={"year"}
                onSearch={onSearch}
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                <Option value="month">Mensile</Option>
                <Option value="year">Annuale</Option>
            </Select>

        </div>
    )
}


